export const emptyMission = ({ username }) => {
  const description =
    "Description:\nA minimal PvE template with only one slot. Perfect for customisation of your orbat from scratch.";
  return {
    description,
    schema: {
      event: {
        event_date: `${new Date().getFullYear()}-01-01T21:00:00Z`,
        event_title: "Default empty TvT",
        event_desc: "Add your google doc briefing link here",
        event_owner: username,
        event_reserves: [],
        event_repo: "MAIN",
      },
      sides: [
        {
          side: "BLU",
          groups: [
            {
              group_data: {
                group_name: "COMMAND",
                group_orbat_icon: "nato_inf",
                group_gear: "",
                group_callsign: "FALCON",
                group_background: "DEFAULT",
              },
              slots: [
                {
                  slot_name: "CO",
                  slot_player: {
                    player_id: "",
                    player_name: "",
                  },
                  slot_shortcode: "CO",
                  slot_gear: "SPAR-16 CARBINE",
                  slot_restricted: false,
                  slot_locked: false,
                  slot_icon_code: "SL",
                  slot_dlc: [],
                  slot_raffle: false,
                  raffle_winner: {
                    player_id: "",
                    player_name: "",
                  },
                  raffle_entrants: [],
                },
              ],
              child: [],
            },
          ],
        },
      ],
    },
  };
};
